import DataTable from "../../Reusable/DataTable/FleetDataTable";
import NACell from "../../Reusable/DataTable/NACell";
import APIS from "../../../constant/EndPoint";
import TableActionButton from "../../Reusable/TableActionButton";

const VehicleCategoryList = () => {

  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },

    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.VEHILCE_CATEGORY}
      queryKey={"vehicle-category"}
      columns={defaultColumns}
      addNewPagePath={"/create-vehicle-category"}
      tableName={"Vehicle Category"}
    />
  );
};

export default VehicleCategoryList;
